import { PaletteGradient, ThemeGradientsColors } from "./palette.types";

//Base colors
export const blue = "#5F8AFA";
export const lightGreen = "#30C3A3";
export const green = "#037F7F";
export const gold = "#FFC860";
export const red = "#DB5555";
export const aqua = "#4FD1D9";
export const purple = "#6B6EF9";
export const lilac = "#A463B0";
export const lavender = "#EAE8F5";
export const orange = "#E3935B";
export const white = "#FFFFFF";
export const black = "#000000";
export const info = "#0288D1";
export const yellow = "#FFE375";
export const success = lightGreen;
export const warning = yellow;
export const error = red;
export const violet = "#43398E";

//Base gradients
const greenDarkGreen: PaletteGradient = [lightGreen, green];
export const gradient: ThemeGradientsColors = {
    blueTurquoise: [blue, aqua],
    lilacBlue: [lilac, blue],
    lilacOrange: [lilac, orange],
    lilacRed: [lilac, red],
    blueGreen: [blue, green],
    bluePurple: [blue, purple],
    purpleLilac: [purple, lilac],
    purpleTurquoise: [purple, aqua],
    purpleRed: [purple, red],
    redOrange: [red, orange],
    orangeYellow: [orange, gold],
    greenYellow: [green, gold],
    greenDarkGreen,
    primary: greenDarkGreen,
};
